import styled from 'styled-components'
import { Heading } from './shared.styles'
import { Input } from '@components/Field'

export const NameField = styled(Input)`
	margin-top: 12px;
`

export const SectionHeading = styled(Heading)`
	margin-top: 40px;
`
